"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhotoIdScanStatusResultToJSON = exports.PhotoIdScanStatusResultFromJSONTyped = exports.PhotoIdScanStatusResultFromJSON = void 0;
const _1 = require("./");
function PhotoIdScanStatusResultFromJSON(json) {
    return PhotoIdScanStatusResultFromJSONTyped(json, false);
}
exports.PhotoIdScanStatusResultFromJSON = PhotoIdScanStatusResultFromJSON;
function PhotoIdScanStatusResultFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'scanStatus': _1.DocumentScanStatusEnumFromJSON(json['scanStatus']),
    };
}
exports.PhotoIdScanStatusResultFromJSONTyped = PhotoIdScanStatusResultFromJSONTyped;
function PhotoIdScanStatusResultToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'scanStatus': _1.DocumentScanStatusEnumToJSON(value.scanStatus),
    };
}
exports.PhotoIdScanStatusResultToJSON = PhotoIdScanStatusResultToJSON;
//# sourceMappingURL=PhotoIdScanStatusResult.js.map